import React from 'react';
import PropTypes from 'prop-types';

const ErrorLayout = ({ children }) => (
  <div className="row pad-1-lr">
    <div className="col-md-6 col-md-offset-3 col-xl-4 col-xl-offset-4 margin-4-t">
      { children }
    </div>
  </div>
);

ErrorLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ErrorLayout;
